import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { useField } from 'formik';
import isEmpty from 'lodash/isEmpty';
import FormFieldLabel from '../FormFieldLabel';
import styles from './styles.scss';

const propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  required: PropTypes.bool,
};

const defaultProps = {
  className: undefined,
  inline: undefined,
  required: undefined,
};

const FormFieldRadio = ({
  className,
  name,
  inline,
  options,
  required,
  ...rest
}) => {
  const [field, meta] = useField(name);
  const error = meta.touched && !isEmpty(meta.error);

  const fieldClasses = cx(
    styles.field,
    className,
  );

  const controlClasses = cx(
    inline && styles.inline,
  );

  return (
    <div className={fieldClasses}>
      {options.map((option) => {
        const id = `${field.name}-${option.value}`;

        const labelComponent = (
          <FormFieldLabel
            htmlFor={id}
            inline={inline}
            required={required}
            title={option.label}
          />
        );

        return (
          <div className={controlClasses} key={option.value}>
            {!inline && labelComponent}
            <input
              data-testid={`form-field-radio-${option.value}`}
              {...field}
              {...rest}
              checked={option.value === field.value}
              className={styles.input}
              id={id}
              required={required}
              type="radio"
              value={option.value}
            />
            {inline && labelComponent}
          </div>
        );
      })}
      {error && (
        <div className={styles.message}>
          {meta.error}
        </div>
      )}
    </div>
  );
};

FormFieldRadio.propTypes = propTypes;
FormFieldRadio.defaultProps = defaultProps;

export default FormFieldRadio;
